import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-header bg-primary" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_openBlock(), _createBlock(_component_app_dropdown, { class: "user-menu" }, {
    "dropdown-button": _withCtx(() => [
      _createElementVNode("img", {
        src: 
                    // user && user.picture
                    //     ? user.picture
                    //     :
                        require('@/assets/img/default-profile.png')
                ,
        class: "user-image img-circle elevation-2",
        alt: "User Image"
      }, null, 8, _hoisted_1)
    ]),
    "dropdown-menu": _withCtx(() => [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("img", {
          src: 
                        // user && user.picture
                        //     ? user.picture
                        //     :
                            require('@/assets/img/default-profile.png')
                    ,
          class: "img-circle elevation-2",
          alt: "User Image"
        }, null, 8, _hoisted_3),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userDD && _ctx.userDD.email), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
          class: "btn btn-default btn-flat float-right"
        }, _toDisplayString(_ctx.$t('labels.signOut')), 1)
      ])
    ]),
    _: 1
  }))
}